<template>
    <div class="tpl-search-en">
        <img class="shadows" src="@/home/assets/img/shadow.png" alt="" />

        <div class="search">
            <div class="home-content">
                <div class="input-box">
                    <input
                        type="text"
                        :placeholder="$t('searchPlaceholder')"
                        @keydown.enter="search"
                        v-model="keyword"
                        maxlength="140"
                        @focus="setExpand(true)"
                        @blur="setExpand(false)"
                        @change="changeInput"
                    />
                    <div class="box-end" @click="search">
                        <img width="36" src="@/home/assets/img/search.png" alt="" />
                    </div>
                    <collapseTransition>
                        <div class="search-expand" v-show="showExpand">
                            <div class="search-expand-box">
                                <p class="search-expand-title" v-show="allHistory.length > 0">
                                    {{ $t("searchHistory") }}
                                </p>
                                <div class="search-expand-history" v-show="allHistory.length > 0">
                                    <span v-for="(item, index) in allHistory" @mousedown.stop="selectHistory(item)" :key="`${item}${index}`">
                                        {{ `${item}${index == allHistory.length - 1 ? "" : ","}` }}
                                    </span>
                                </div>
                                <p class="search-expand-title">
                                    {{ $t("trending") }}
                                </p>
                                <div class="search-expand-suggest">
                                    <span v-for="item in suggestList" @mousedown.stop="selectTrending(item.tag_id)" :key="item.tag_id">
                                        {{ item.show_title }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </collapseTransition>
                </div>
            </div>
        </div>

        <div class="search-fixed" :class="{ isPC: isPC }" v-show="showSearch">
            <div class="search-box">
                <iconSymbol name="search" class="search-icon" />
                <input type="text" :placeholder="$t('searchPlaceholder')" @keydown.enter="search" v-model="keyword" maxlength="140" />
                <div class="menu-box">
                    <span @click.stop="showMenu = !showMenu">{{ selectMenu }}</span>
                    <iconSymbol name="menu" @click.native.stop="showMenu = !showMenu" />
                    <transition name="scale-transition">
                        <div class="dropdown-menu" v-if="showMenu" v-click-outside="() => (showMenu = false)">
                            <div
                                @click="clickList(item.lv1id)"
                                class="dropdown-menu-item"
                                v-for="item in editorTags"
                                :key="item.lv1id"
                                :class="{ active: activeMenu === item.lv1id }"
                            >
                                {{ item.lv1name }}
                            </div>
                        </div>
                    </transition>
                </div>
            </div>
        </div>
    </div>
</template>
<i18n>
{
  "zh": {
    "title": "模板社区",
    "subTitle": "发现、学习由我们的编辑策划的顶级EdrawMax视觉作品，并从中获得灵感",
    "searchPlaceholder": "搜索模板",
    "searchHistory": "搜索历史记录",
    "trending": "搜索热词"
  },
  "en": {
    "title": "Templates Community",
    "subTitle": "Discover, learn, and be inspired by the top EdrawMax visuals, curated by our editors",
    "searchPlaceholder": "Search for templates",
    "searchHistory": "Search History",
    "trending": "Trending searches"
  },
  "jp": {
    "title": "テンプレートコミュニティ",
    "subTitle": "EdrawMaxで利用できるテンプレートを検索して「ビジネス・教育・発想」を加速させましょう！",
    "searchPlaceholder": "検索",
    "searchHistory": "検索履歴",
    "trending": "検索キーワード"
  },
  "fr": {
    "title": "Communauté des Modèles",
    "subTitle": "Découvrez, apprenez et laissez-vous inspirer par les meilleurs visuels EdrawMax, sélectionnés par nos éditeurs.",
    "searchPlaceholder": "Rechercher des modèles",
    "searchHistory": "Historique des recherches",
    "trending": "Recherches populaires"
  },
  "de": {
    "title": "Schablonen Gemeinschaft",
    "subTitle": "Entdecken, lernen und lassen Sie sich von den besten EdrawMax-Visualisierungen inspirieren, die von unseren Redakteuren zusammengestellt wurden",
    "searchPlaceholder": "Suche nach Vorlagen",
    "searchHistory": "Suchverlauf",
    "trending": "Trendsuchen"
  },
  "es": {
    "title": "Comunidad de Plantillas",
    "subTitle": "Descubre, aprende e inspírate con las mejores imágenes de EdrawMax, seleccionadas por nuestros editores",
    "searchPlaceholder": "Búsqueda de Plantillas",
    "searchHistory": "Buscar Historia",
    "trending": "Tendencias de búsquedas"
  },
  "pt": {
    "title": "Comunidade de Modelos",
    "subTitle": "Descubra, aprenda e seja inspirado pelos principais recursos visuais do EdrawMax, que curado pelos nossos editores",
    "searchPlaceholder": "Pesquisar modelos",
    "searchHistory": "Histórico de busca",
    "trending": "Tendências de pesquisas"
  },
  "it": {
    "title": "Comunità di Modelli",
    "subTitle": "Scopri, impara e lasciati ispirare dalle migliori immagini di EdrawMax, curate dai nostri editor",
    "searchPlaceholder": "Cerca modelli",
    "searchHistory": "Cronologia delle ricerche",
    "trending": "Ricerche di tendenza"
  },
  "tw": {
    "title": "範本社區",
    "subTitle": "發現、學習由我們的編輯策劃的頂級EdrawMax視覺作品，並從中獲得靈感",
    "searchPlaceholder": "蒐索範本",
    "searchHistory": "搜索歷史記錄",
    "trending": "搜尋熱詞"
  },
  "kr": {
    "title": "템플릿 갤러리",
    "subTitle": "템플릿 갤러리에서 다이어그램 영감을 얻어보세요!",
    "searchPlaceholder": "템플릿 검색",
    "searchHistory": "검색 기록",
    "trending": "인기많은 검색어"
  },
  "id": {
    "title": "Komunitas Templat",
    "subTitle": "Temukan, pelajari, dan dapatkan inspirasi dari visual EdrawMax terbaik, yang dibuat oleh editor kami",
    "searchPlaceholder": "Mencari templat",
    "searchHistory": "Riwayat Pencarian",
    "trending": "Pencarian yang sedang tren"
  }
}
</i18n>
<script lang="ts">
    import { Component, Vue, Watch } from "vue-property-decorator";
    import collapseTransition from "@/public/utils/collapse-transition.js";
    import { isEmpty } from "@/public/utils/tool";
    @Component({
        components: {
            collapseTransition,
        },
    })
    export default class tplSearchEn extends Vue {
        keyword = "";
        setSearchKey(data) {
            this.keyword = data;
            this.search();
        }
        clearSearch() {
            this.keyword = "";
            this.$emit("search", { doSearch: false, keyword: "" });
        }
        timer = NaN;
        changeInput() {
            clearTimeout(this.timer);
            this.timer = setTimeout(() => {
                if (this.keyword == "") {
                    this.$bus.$emit("setActiveMenu");
                    this.$emit("search", { doSearch: true, keyword: "" });
                }
            }, 500);
        }
        search() {
            //搜索
            let keyword = this.keyword.trim().replace(/\s+/g, " ");
            if (keyword) {
                this.updateHistory(keyword);
            }
            this.$emit("search", { doSearch: true, keyword, stopResetClass: true });
        }
        showExpand = false;
        setExpand(data: boolean) {
            this.showExpand = data;
        }
        allHistory = [];
        getAllHistory() {
            let oldData = localStorage.getItem("search-history");
            if (oldData) {
                localStorage.removeItem("search-history");
                localStorage.setItem("search-history-en", oldData.split(",").reverse().slice(0, 6).join(","));
            }
            let newData = localStorage.getItem("search-history-en");
            if (newData) {
                this.allHistory = newData.split(",");
            }
        }
        updateHistory(word) {
            //更新历史记录
            let index = this.allHistory.indexOf(word);

            if (index != -1) {
                //已经存在记录，把记录放到最前面
                this.allHistory.splice(index, 1);
                this.allHistory.unshift(word);
            } else {
                this.allHistory.unshift(word);
                this.allHistory = this.allHistory.slice(0, 6);
            }
            localStorage.setItem("search-history-en", this.allHistory.join(","));
        }
        get editorTags() {
            return this.$store.state.tplCenter.editorTags;
        }
        selectHistory(keyword) {
            //查找被点击的记录
            this.updateHistory(keyword);
            this.keyword = keyword;
            this.$bus.$emit("setActiveMenu");
            //更新作品
            this.$emit("search", { doSearch: true, keyword });
        }
        suggestList = [];
        getTrendingSearch() {
            this.$edApi.getTrendingSearch({ lang: this.lang }).then((data) => {
                this.suggestList = data;
            });
        }
        @Watch("lang")
        langChange() {
            this.getTrendingSearch();
        }
        selectTrending(data) {
            this.$store.commit("setState", {
                type: "templateSelect",
                data: "tagInfo",
            });
            this.$store.commit("setState", {
                type: "tagId",
                data,
            });
            this.$store.commit("setState", {
                type: "fromAllTags",
                data: false,
            });
        }
        clearHistory() {
            localStorage.removeItem("search-history-en");
            localStorage.removeItem("search-history");
            this.allHistory = [];
        }
        created() {
            this.getAllHistory();
            this.getTrendingSearch();
            this.$bus.$on("setSearchKey", this.setSearchKey);
            this.$bus.$on("clearSearch", this.clearSearch);
            this.$once("hook:beforeDestroy", () => {
                this.$bus.$off("setSearchKey", this.setSearchKey);
                this.$bus.$off("clearSearch", this.clearSearch);
            });
        }
        get activeMenu() {
            return this.$store.state.activeMenu;
        }
        get selectMenu() {
            if (isEmpty(this.editorTags) || !this.activeMenu) {
                return "All";
            }
            return this.editorTags.find((item) => item.lv1id === this.activeMenu).lv1name;
        }
        get showSearch() {
            return this.$store.state.showSearch;
        }
        showMenu = false;
        clickList(id) {
            this.$bus.$emit("clickList", id);
            this.showMenu = false;
        }

        mounted() {
            if (this.$route.query?.keyword) {
                setTimeout(() => {
                    this.keyword = (this.$route.query.keyword as string) || "";
                    this.search();
                }, 200);
            }
        }
    }
</script>

<style lang="stylus" scoped>
    .tpl-search-en{


        .scale-transition-enter-active, .scale-transition-leave-active {
            transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1) !important;
        }
        .scale-transition-move {
            transition: transform 0.6s;
        }
        .scale-transition-enter, .scale-transition-leave, .scale-transition-leave-to {
            opacity: 0;
            transform: scale(0);
        }

        position: relative;
        .search-fixed{
            position: fixed;
            width: calc(100vw - 210px);
            top: 44px;
            left: 210px;
            z-index: 10;
            display: flex;
            justify-content: center;
            background: #FFFFFF;
            height: 48px;
            align-items: center;
            &.isPC{
                top: 0;
                width: 100%;
                left: 0;
            }
            .search-box{
                position: relative;
                display: flex;
                justify-content: center;
                align-items: center;
                .search-icon{
                    width: 20px;
                    height: 20px;
                    position: absolute;
                    left: 16px;
                    transform: translateY(-50%);
                    top: 50%;
                }
                input{
                    width: 438px;
                    height: 36px;
                    background: #FFFFFF;
                    border: 1px solid #000000;
                    box-sizing: border-box;
                    border-radius: 24px;
                    font-size: 14px;
                    &::placeholder{
                        color: rgba(0, 0, 0, 0.4);
                    }
                    padding-left: 40px;
                    outline: none;
                }
                .menu-box{
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    margin-left: 34px;
                    position: relative;
                    user-select: none;
                    span{
                        font-size: 18px;
                        margin-right: 4px;
                        white-space: nowrap;
                    }
                    svg{
                        width: 17px;
                        height: 14px;
                    }
                    .dropdown-menu{
                        transform-origin: center top 0px;
                        background: #fff;
                        box-shadow: 0px 20px 40px rgba(8, 37, 111, 0.1);
                        filter: drop-shadow(0 4px 4px rgba(0,0,0,.25));
                        border-radius: 8px;
                        padding: 8px 12px;
                        width: 235px;
                        top: 31px;
                        left: -23px;
                        position: absolute;
                        .dropdown-menu-item{
                            border-radius: 8px;
                            font-size: 16px;
                            line-height: 16px;
                            padding: 16px 12px;
                            &.active {
                                background: #f2f9ff;
                                color: #017fff;
                            }
                        }
                    }
                }
            }

        }
        .shadows {
    		position: absolute;
    		top: 0;
    		left: 0;
    		width: 100%;
            pointer-events: none;
    	}
        .search-expand {
            width: 100%;
            background: #fff;
            position: absolute;
            top: 58px;
            left: 0;

            box-shadow: 0px 20px 40px rgba(8, 37, 111, 0.1);
            border-radius: 16px;
            z-index: 1;
            .search-expand-box {
                padding: 24px 32px;
            }
            .search-expand-title {
                height: 24px;
                line-height: 24px;
                margin-bottom: 16px;
                font-family: Poppins;
                font-style: normal;
                font-weight: 500;
                font-size: 14px;
                line-height: 28px;
                color: #454545;
            }
            .search-expand-history {
                margin-bottom: 36px;
                word-break: break-word;
                span {
                    font-family: Poppins;
                    font-style: normal;
                    font-weight: 500;
                    font-size: 18px;
                    line-height: 28px;
                    color: #000000;
                    cursor: pointer;
                    &:hover {
                        color: #017fff;
                    }
                }
            }
            .search-expand-suggest {
                display: flex;
                flex-wrap: wrap;
                span {
                    display: flex;
                    flex-direction: row;
                    justify-content: center;
                    align-items: center;
                    height: 40px;
                    margin-right: 16px;
                    margin-bottom: 16px;
                    font-size: 16px;
                    color: #000;
                    font-weight: 500;
                    padding: 10px 24px;
                    border: 1px solid rgba(0, 0, 0, 0.1);
                    box-sizing: border-box;
                    border-radius: 47px;
                    cursor: pointer;
                    transition: all 0.2s;
                    &:hover {
                        border-color: #017fff;
                        color: #017fff;
                    }
                }
            }
        }

        .search {
    	    position: relative;
            .home-content {
                max-width: 950px;
                width: 100%;
                margin: 0 auto;
                padding-top:48px;
                position: relative;
                @media screen and (max-width: 1280px)  {
                    padding-top: 42px
                }
                @media screen and (max-width: 768px) {
                    padding-top: 36px;
                }
                .titles {
                    font-weight: bold;
                    font-size: 52px;
                    line-height: 55px;
                    text-align: center;
                    color: #000000;
                    @media screen and (max-width: 1280px)  {
                        font-size: 36px;
                        line-height: 36px;
                    }
                    @media screen and (max-width: 768px) {
                        font-size: 36px;
                    }
                }
                .sub-titles {
                    font-weight: 500;
                    font-weight: 500;
                    font-size: 18px;
                    line-height: 32px;
                    margin-top: 8px;
                    text-align: center;
                    color: #000000;
                    @media screen and (max-width: 1280px)  {
                        font-size: 12px;
                        line-height: 12px;
                    }
                    @media screen and (max-width: 768px) {
                        font-size: 14px;
                    }
                }
                .input-box {
                    box-shadow: 0px 25px 49px rgba(8, 37, 111, 0.1);
                    display: flex;
                    height: 60px;
                    background: #fff;

                    border: 2px solid #000000;
                    border-radius: 12px;
                    max-width: 706px;
                    margin-left: auto;
                    margin-right: auto;

                    justify-content: space-between;
                    align-items: center;
                    position: relative;

                    input {
                        font-size: 16px;
                        outline: none;
                        border: 0;
                        flex: 1;
                        margin-left: 36px;
                        height: 100%;
                        &::placeholder {
                            color: rgba(0, 0, 0, 0.4);
                        }
                    }
                    .box-end {
                        border-left: 1px solid #000;
                        display: flex;
                        align-items: center;
                        padding-left: 18px;
                        padding-right: 18px;
                        img{
                            width: 24px;
                            cursor: pointer;
                        }
                    }

                    @media screen and (max-width: 768px) {
                        margin: 0px 15px;
                        margin-top: 30px;
                        height: 68px;

                        input {
                            font-size: 16px;
                            margin-left: 16px;
                        }
                    }
                }
            }
        }
    }
</style>
